/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as FarmsRouteImport } from './routes/farms'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShopIndexRouteImport } from './routes/shop/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as FarmerIndexRouteImport } from './routes/farmer/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ShopSlugRouteImport } from './routes/shop/$slug'
import { Route as OrdersIdRouteImport } from './routes/orders/$id'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'

const FarmsRoute = FarmsRouteImport.update({
  id: '/farms',
  path: '/farms',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopIndexRoute = ShopIndexRouteImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const FarmerIndexRoute = FarmerIndexRouteImport.update({
  id: '/farmer/',
  path: '/farmer/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopSlugRoute = ShopSlugRouteImport.update({
  id: '/shop/$slug',
  path: '/shop/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIdRoute = OrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/farms': typeof FarmsRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/orders/$id': typeof OrdersIdRoute
  '/shop/$slug': typeof ShopSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/farmer/': typeof FarmerIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/shop/': typeof ShopIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/farms': typeof FarmsRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/orders/$id': typeof OrdersIdRoute
  '/shop/$slug': typeof ShopSlugRoute
  '/admin': typeof AdminIndexRoute
  '/farmer': typeof FarmerIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/shop': typeof ShopIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/farms': typeof FarmsRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/orders/$id': typeof OrdersIdRoute
  '/shop/$slug': typeof ShopSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/farmer/': typeof FarmerIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/shop/': typeof ShopIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/cart'
    | '/checkout'
    | '/farms'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/orders/$id'
    | '/shop/$slug'
    | '/admin/'
    | '/farmer/'
    | '/orders/'
    | '/shop/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/cart'
    | '/checkout'
    | '/farms'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/orders/$id'
    | '/shop/$slug'
    | '/admin'
    | '/farmer'
    | '/orders'
    | '/shop'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/cart'
    | '/checkout'
    | '/farms'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/orders/$id'
    | '/shop/$slug'
    | '/admin/'
    | '/farmer/'
    | '/orders/'
    | '/shop/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  FarmsRoute: typeof FarmsRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  OrdersIdRoute: typeof OrdersIdRoute
  ShopSlugRoute: typeof ShopSlugRoute
  AdminIndexRoute: typeof AdminIndexRoute
  FarmerIndexRoute: typeof FarmerIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  ShopIndexRoute: typeof ShopIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/farms': {
      id: '/farms'
      path: '/farms'
      fullPath: '/farms'
      preLoaderRoute: typeof FarmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop/': {
      id: '/shop/'
      path: '/shop'
      fullPath: '/shop/'
      preLoaderRoute: typeof ShopIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/farmer/': {
      id: '/farmer/'
      path: '/farmer'
      fullPath: '/farmer/'
      preLoaderRoute: typeof FarmerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop/$slug': {
      id: '/shop/$slug'
      path: '/shop/$slug'
      fullPath: '/shop/$slug'
      preLoaderRoute: typeof ShopSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$id': {
      id: '/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof OrdersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  FarmsRoute: FarmsRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  OrdersIdRoute: OrdersIdRoute,
  ShopSlugRoute: ShopSlugRoute,
  AdminIndexRoute: AdminIndexRoute,
  FarmerIndexRoute: FarmerIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  ShopIndexRoute: ShopIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
